import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from '@/shared/utils/requestBuilder';
import { parseApiResponse } from '@/shared/utils/apiResponse';

export interface AdminPortalFaqItem {
  id: string;
  empresaId: string;
  pergunta: string;
  resposta: string;
  ordemExibicao: number;
  ativo: boolean;
  dataCriacao: string;
  dataAtualizacao: string;
}

export interface AdminPortalFaqCreatePayload {
  pergunta: string;
  resposta: string;
}

export interface AdminPortalFaqUpdatePayload {
  pergunta?: string;
  resposta?: string;
  ativo?: boolean;
}

const BASE = '/admin/portal-faq';

export const portalFaqServices = {
  list: async (ativo?: boolean): Promise<AdminPortalFaqItem[]> => {
    const params = ativo !== undefined ? { ativo: String(ativo) } : undefined;
    const response = await apiGet(BASE, params);
    return await parseApiResponse<AdminPortalFaqItem[]>(response);
  },

  getById: async (id: string): Promise<AdminPortalFaqItem> => {
    const response = await apiGet(`${BASE}/${id}`);
    return await parseApiResponse<AdminPortalFaqItem>(response);
  },

  create: async (payload: AdminPortalFaqCreatePayload): Promise<AdminPortalFaqItem> => {
    const response = await apiPost(BASE, payload);
    return await parseApiResponse<AdminPortalFaqItem>(response);
  },

  update: async (id: string, payload: AdminPortalFaqUpdatePayload): Promise<AdminPortalFaqItem> => {
    const response = await apiPut(`${BASE}/${id}`, payload);
    return await parseApiResponse<AdminPortalFaqItem>(response);
  },

  delete: async (id: string): Promise<void> => {
    const response = await apiDelete(`${BASE}/${id}`);
    await parseApiResponse<void>(response);
  },

  reorder: async (orderedIds: string[]): Promise<void> => {
    const response = await apiPatch(BASE + '/reorder', { orderedIds });
    await parseApiResponse<void>(response);
  },
};
